export default __webpack_public_path__ + "static/media/icons8-unpin-96.1c2ff0a4.svg";